import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import Cookies from "js-cookie";

/**
 * 自定义 Hook：检查用户身份验证状态
 * 如果用户未登录，则重定向到登录页
 */
const useAuth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("token");
    const user = Cookies.get("user");

    if (!token || !user) {
      message.warning("请先登录");
      navigate("/", { replace: true });
    }
  }, [navigate]);

  // 返回用户信息
  const getUser = () => {
    const userStr = Cookies.get("user");
    return userStr ? JSON.parse(userStr) : null;
  };

  const getToken = () => {
    return Cookies.get("token");
  };

  return { getUser, getToken };
};

export default useAuth;
